import React from "react"
import { Link } from "gatsby"

import { getPostUrl, camelize } from "components/utils"

import PostImage from "components/blog/post-image"
import Title from "components/elements/title"
import PostCategory from "components/blog/post-category"
import PostInfo from "components/blog/post-info"
import Hr from "components/elements/hr"

import cx from "classnames"
import * as s from "./post.module.sass"

const Post = (props) => {
  const { post, index } = props

  const { slug, title, category, featuredImage, author, publishedDate } = post
  const postUrl = getPostUrl(slug)

  const componentClass = cx({
    [s.component]: true,
    [s[camelize(`index${index}`)]]: index !== null,
  })

  const fullsize = index === 0;

  return (
    <div className={componentClass}>
      <PostImage parentClass={s.image} image={featuredImage} to={postUrl} fullsize={fullsize}  />

      <div className={s.content}>
        <PostCategory parentClass={s.category} category={category}/>

        <Title parentClass={s.title}>
          <Link to={postUrl}>{title}</Link>
        </Title>

        <PostInfo
          parentClass={s.info}
          author={author}
          publishedDate={publishedDate}
        />

        <Hr parentClass={s.hr} />
      </div>
    </div>
  )
}

export default Post
